import { Component, DestroyRef, OnInit } from '@angular/core';
import { Observable, finalize, map } from 'rxjs';
import { CompanyService } from 'src/app/shared/services/company.service';
import { CompanyProduct, CompanyResult } from 'src/app/shared/interfaces/company-interface';
import { DomainsService } from 'src/app/shared/services/domains.service';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-end-trial-period',
  templateUrl: './end-trial-period.component.html',
  styleUrls: ['./end-trial-period.component.less'],
  standalone: true,
  imports: [NzSpinModule, NzIconModule],
})
export class EndTrialPeriodComponent implements OnInit {
  public company$!: Observable<CompanyResult | null>;

  private hasPartner!: boolean;

  private isExpert!: boolean;

  public duration: number = 0;

  public partnerLabel: string = 'revendeur';

  public display: boolean = false;

  public isOwner: boolean = true;

  public readonly DAYS: number = 365;

  public constructor(
    private readonly companyService: CompanyService,
    private readonly domainService: DomainsService,
    private readonly destroyRef: DestroyRef,
  ) {}

  public ngOnInit(): void {
    this.domainService.currentDomain$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((domaine) => {
      if (domaine !== null) {
        this.isOwner = domaine.isOwner;
        this.getAndApplyCompany();
      }
    });
  }

  private getAndApplyCompany(): void {
    this.company$ = this.companyService.currentCompany$;
    this.company$
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map((companyResult: CompanyResult | null) => {
          this.hasPartner =
            companyResult?.products?.some((product: CompanyProduct) => product.partnerCode !== null) ?? false;

          if (this.hasPartner) {
            const partnerCode: string =
              companyResult?.products.filter((product: CompanyProduct) => product.partnerCode !== null)[0]
                .partnerCode ?? '';
            this.companyService
              .getPartnerIsExpert(partnerCode)
              .pipe(
                takeUntilDestroyed(this.destroyRef),
                finalize(() => {
                  this.display = true;
                }),
                map((isExpert) => {
                  this.isExpert = isExpert;
                  this.partnerLabel = this.isExpert ? 'expert' : 'revendeur';
                }),
              )
              .subscribe();
          } else {
            this.display = true;
          }

          this.duration =
            (new Date(companyResult?.products[0].dueDate!).getTime() -
              new Date(companyResult?.products[0].subscriptionDate!).getTime()) /
            (1000 * 60 * 60 * 24);
        }),
      )
      .subscribe();
  }
}
